import { Injectable, Scopes } from '@visiba/instantiation';
import { ApiBaseClient } from './_api_base_client';
import { HttpResponse, HttpService } from '@application/http.service';
import type { HomeGuiComponentsApiModel, Locale } from './generated/clientv2/models';

@Injectable({
	scope: Scopes.Transient,
})
export class LicenceHolderApi extends ApiBaseClient {
	constructor(private readonly httpService: HttpService) {
		super();
	}

	public getHomeGuiComponents(licenceHolderId: number): HttpResponse<HomeGuiComponentsApiModel> {
		return this.httpService.get(`${this.baseUri}/${licenceHolderId}/HomeGuiComponents`);
	}

	public getLocale(licenceHolderId: number): HttpResponse<Locale> {
		return this.httpService.get(`${this.baseUri}/${licenceHolderId}/locale`);
	}

	public getTheme(licenceHolderId: number): HttpResponse<Record<string, string>> {
		return this.httpService.get(`${this.baseUri}/${licenceHolderId}/theme/public`);
	}

	public getMethods(licenceHolderId: number): HttpResponse<
		{
			Scheme: 'string';
			Name: 'string';
			Description: 'string';
			UseIframe: boolean;
		}[]
	> {
		// Why tf is this not v2 when it's new?
		return this.httpService.get(`/client/auth/idp/${licenceHolderId}/methods`);
	}
}
